<template>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <input type="hidden" :disabled="Validate">
            <input type="hidden" :value="ValidateFiltros">

            <div class="card">
                <div class="card-header pb-0">
                    <div class="row">
                        <div class="col-6 d-flex align-items-center">
                            <h6>
                                <span v-if="ConfigList.ShowTitleFirst">{{ConfigList.TitleFirst}} / </span>
                                <span v-if="ConfigList.ShowTitleEnd">{{ConfigList.Title}}</span>
                            </h6>
                        </div>

                        <div class="col-6 text-end">

                            <slot name="accHeader"></slot>

                            <div class="btn-group" role="group" aria-label="basic">

                                <button type="button" v-if="ConfigList.BtnReturnShow" @click="RunReturn" class="btn btn-sm btn-primary">
                                    <i class="fas fa-arrow-left"></i>
                                    {{ConfigList.BtnReturnName}}
                                </button>

                                <slot name="BtnExtra"></slot>
                                <!-- <button type="button" class="btn btn-sm btn-primary"><i class="fas fa-file-excel"></i> Descargar</button> -->

                                 <template v-if="objSegurity.Add">
                                    <template v-if="ConfigList.BtnNewShow">
                                        <button type="button" @click="RunNew(0)" class="btn btn-sm btn-primary">
                                            <i class="fas fa-plus" aria-hidden="true"></i>
                                            {{ConfigList.BtnNewName}}
                                        </button>
                                    </template>
                                </template>

                            </div>
                        </div>
                    </div>
                </div>

                <div :class="['card-body px-0 pt-0', (ConfigList.TypeBody == 'List')? 'pb-2': 'pb-4']">
                    <!-- Filtros -->
                    <div v-if="ConfigList.ShowFiltros" class="row g-3 align-items-center px-4">

                        <div v-if="ConfigList.ShowSearch" class="col-auto" >
                            <div class="search">
                                <input type="text" @input="Search" v-model="FiltroC.Nombre" class="form-control p-icon" :placeholder="FiltroC.Placeholder" size="40" autocomplete="off">
                            </div>
                        </div>

                        <template v-if="ConfigList.ShowEntradas">
                            <div class="col-auto">
                                <label class="col-form-label text-primary">Filas</label>
                            </div>
                            <div class="col-auto">
                                <select @change="Search" v-model="FiltroC.Entrada" class="form-select form-control-search" aria-label="Default select example">
                                    <option :value="10">10</option>
                                    <option :value="25">25</option>
                                    <option :value="50">50</option>
                                    <option :value="100">100</option>
                                </select>
                            </div>
                        </template>

                        <template v-if="ConfigList.ShowYear">
                            <div class="col-auto">
                                <label class="col-form-label text-primary">Año:</label>
                            </div>
                            <div class="col-auto">
                                <select @change="Search" v-model="FiltroC.Anio" class="form-select form-control-search">
                                    <option v-for="(itemY,indexY) in ListYears" :key="indexY" :value="itemY">{{itemY}}</option>
                                </select>
                            </div>
                        </template>

                        <template v-if="ConfigList.ShowMonth">
                            <div class="col-auto">
                                <label class="col-form-label text-primary">Mes:</label>
                            </div>
                            <div class="col-auto">
                                <select @change="Search" v-model="FiltroC.Mes" class="form-select form-control-search">
                                    <option v-for="(meses,ind) in ListMonths" :key="ind" :value="meses.Mes">{{meses.Nombre}}</option>
                                </select>
                            </div>
                        </template>

                        <slot name="Filtros"></slot>
                        
                    </div>
                    
                    <template v-if="ConfigList.TypeBody == 'List'">
                        <slot name="AntTabla"></slot>
                        <div class="table-responsive pb-0">
                            <CLoader :pConfigLoad="ConfigLoad">
                                <template slot="BodyFormLoad">
                                    <table class="table align-items-center mb-0">
                                        <thead>
                                            <tr>
                                                <slot name="header"></slot>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <slot name="body"></slot>
                                            <slot name="botones"></slot>
                                        </tbody>
                                    </table>
                                </template>
                            </CLoader>
                        </div>
                    </template>
                   
                    <template v-else>
                        <div class="container-fluid sinbordemovil">
                            <slot name="bodyForm"></slot>
                            <slot name="botones"></slot>
                        </div>
                    </template>


                    <CPagina v-if="ConfigList.ShowPaginador" :Filtro="pFiltro" @Pagina="Search"></CPagina>

                </div>
            </div>
            
        
        </div>

        <CFooter v-if="ConfigList.ShowFooter"></CFooter>
    </div>
</template>

<script>

/*****
# pConfigList   == CONTIENE TODAS LAS CONFIGURACIONES VISUALES DEL CLIST, PARA CONTROLAR LOS ELEMENTOS DEL MISMO
# pFiltro       == CONTIENE TODAS LAS CONFIGURACIONES QUE SE NECESITAN PARA HACER EL FILTRADO, SIRVE TAMBIEN A CPAGINA
# segurity      == CONTIENE TODOS LOS PERMISOS PARA RESTRINGIR LA VISUALIZACION DEL BOTON NUEVO O ALGUNA ACCION ADICIONAL
*****/

export default {
    name:  "CList",
    props:['pConfigList','pFiltro','segurity','Nombre'],
    components:{},
    data() {
        return {
            ConfigList:{
                Title:          'Listado',
                TitleFirst:     'Inicio',
                IsModal:        true,
                BtnNewShow:     true,
                BtnNewName:     'Nuevo',
                BtnReturnShow:  false,
                BtnReturnName:  'Regresar',
                ShowFiltros:    true,
                ShowSearch:     true,
                ShowEntradas:   true,
                ShowPaginador:  true,
                ShowYear:       false,
                ShowMonth:      false,
                TypeBody:       'List',
                GoRoute:        '',
                EmitSeccion:    '',
                ShowTitleFirst: true,
                ShowTitleEnd:   true,
                Obj:            {}, //declara cualquier objeto para enviar al form
                ShowFooter: true,
            },
            FiltroC:{
                Nombre:      '',
                Entrada:     50,
                Placeholder: 'Buscar..',
                Anio:        '',
                Mes:         0,
            },
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad:  true,
            },
            ListYears:[],
            ListMonths: [
                {Mes:'0',Nombre:'Elija un mes'},
                {Mes:'01',Nombre:'Enero'},
                {Mes:'02',Nombre:'Febrero'},
                {Mes:'03',Nombre:'Marzo'},
                {Mes:'04',Nombre:'Abril'},
                {Mes:'05',Nombre:'Mayo'},
                {Mes:'06',Nombre:'Junio'},
                {Mes:'07',Nombre:'Julio'},
                {Mes:'08',Nombre:'Agosto'},
                {Mes:'09',Nombre:'Septiembre'},
                {Mes:'10',Nombre:'Octubre'},
                {Mes:'11',Nombre:'Noviembre'},
                {Mes:'12',Nombre:'Diciembre'},
            ],
            TimeOut: null,
            objSegurity:{},
        }
    },
    methods :{
        RunNew()
        {
            // EJECUTA EL EMIT DEL NUEVO PARA LLAMAR A LA FUNCION GET ONE DE LOS FORMULARIOS
            // SINO LLAMA AL ROUTER PUSH PARA IR A LA RUTA INDICADA
            if(this.ConfigList.IsModal==true) {
                this.bus.$emit('NewModal_'+this.ConfigList.EmitSeccion,0,this.ConfigList.Obj);
            }  else {
                this.$router.push({name:this.ConfigList.GoRoute,params:{Id:0,Obj:this.ConfigList.Obj}})
            }
        },
        RunReturn()
        {
            if(this.ConfigList.TypeBody == 'List' && this.ConfigList.BtnReturnShow == false) {
                this.$router.push({name: 'inicio'});
            } else {
                this.bus.$emit('EmitReturn');
            }
        },
        Search()
        {
            if(this.pFiltro !=undefined)
            {
                if(this.FiltroC.Entrada != this.pFiltro.Entrada) {
                    this.pFiltro.Pagina  = 1;
                }

                this.pFiltro.Nombre  = this.FiltroC.Nombre;
                this.pFiltro.Entrada = this.FiltroC.Entrada;
                this.pFiltro.Anio    = this.FiltroC.Anio;

                if(this.FiltroC.Nombre!='')
                {
                    clearTimeout(this.TimeOut);

                    this.TimeOut = setTimeout(() => {
                        this.$emit('FiltrarC');
                    }, 1000);
                }
                else
                {
                    this.$emit('FiltrarC');
                }
            }
        },
        GetYearConfig() {
            //this.ListYears = JSON.parse(sessionStorage.getItem('ListYears'));
        },
        GetMonthFilter(buscar)
        {
            let aBuscar  = buscar;
            let devuelve = '';

            let arr = this.ListMonths.filter(function(vl) {
                if(aBuscar!='') {
                    if(aBuscar == vl.Mes) {
                        return vl;
                    }  else {
                        return '';
                    }
                }
            });

            if(arr[0]) {
                devuelve = arr[0].Nombre;
            }

            return devuelve;
        },
    },
    created() {
        this.GetYearConfig();
    },
    computed: {
        Validate()
        {
            if(this.pConfigList.Title != undefined){
                this.ConfigList.Title = this.pConfigList.Title;
            }
            if(this.pConfigList.IsModal != undefined){
                this.ConfigList.IsModal = this.pConfigList.IsModal;
            }
            if(this.pConfigList.BtnNewShow != undefined){
                this.ConfigList.BtnNewShow = this.pConfigList.BtnNewShow;
            }
            if(this.pConfigList.BtnNewName != undefined){
                this.ConfigList.BtnNewName = this.pConfigList.BtnNewName;
            }
            if(this.pConfigList.BtnReturnShow != undefined){
                this.ConfigList.BtnReturnShow = this.pConfigList.BtnReturnShow;
            }
            if(this.pConfigList.BtnReturnName != undefined){
                this.ConfigList.BtnReturnName = this.pConfigList.BtnReturnName;
            }
            if(this.pConfigList.ShowFiltros != undefined){
                this.ConfigList.ShowFiltros = this.pConfigList.ShowFiltros;
            }
            if(this.pConfigList.ShowSearch != undefined){
                this.ConfigList.ShowSearch = this.pConfigList.ShowSearch;
            }
            if(this.pConfigList.ShowEntradas != undefined){
                this.ConfigList.ShowEntradas = this.pConfigList.ShowEntradas;
            }
            if(this.pConfigList.ShowPaginador != undefined){
                this.ConfigList.ShowPaginador = this.pConfigList.ShowPaginador;
            }
            if(this.pConfigList.ShowYear != undefined){
                this.ConfigList.ShowYear = this.pConfigList.ShowYear;
            }
            if(this.pConfigList.ShowMonth != undefined){
                this.ConfigList.ShowMonth = this.pConfigList.ShowMonth;
            }
            if(this.pConfigList.ShowLoader != undefined){
                this.ConfigLoad.ShowLoader = this.pConfigList.ShowLoader;
            }
            if(this.pConfigList.ClassLoad != undefined){
                this.ConfigLoad.ClassLoad = this.pConfigList.ClassLoad;
            }
            if(this.pConfigList.GoRoute != undefined){
                this.ConfigList.GoRoute = this.pConfigList.GoRoute;
            }
            if(this.pConfigList.TypeBody != undefined){
                this.ConfigList.TypeBody = this.pConfigList.TypeBody;
            }
            if(this.pConfigList.EmitSeccion != undefined){
                this.ConfigList.EmitSeccion = this.pConfigList.EmitSeccion;
            }
            if(this.pConfigList.Obj != undefined){
                this.ConfigList.Obj = this.pConfigList.Obj;
            }
            if(this.pConfigList.TitleFirst != undefined){
                this.ConfigList.TitleFirst = this.pConfigList.TitleFirst;
            }
            if(this.pConfigList.ShowTitleFirst != undefined){
                this.ConfigList.ShowTitleFirst = this.pConfigList.ShowTitleFirst;
            }
            if(this.pConfigList.ShowTitleEnd != undefined){
                this.ConfigList.ShowTitleEnd = this.pConfigList.ShowTitleEnd;
            }
            if(this.segurity!=undefined){
                this.objSegurity = this.segurity;
            }            
            if(this.Nombre!=undefined) {
                this.ConfigList.Title = this.Nombre;
            }
            if(this.pConfigList.ShowFooter != undefined){
                this.ConfigList.ShowFooter = this.pConfigList.ShowFooter;
            }

            return this.ConfigList.IsModal;
        },
        ValidateFiltros()
        {
            if(this.pFiltro !=undefined)
            {
                if(this.pFiltro.Nombre!=undefined){
                    this.FiltroC.Nombre = this.pFiltro.Nombre;
                }
                if(this.pFiltro.Placeholder!=undefined){
                    this.FiltroC.Placeholder = this.pFiltro.Placeholder;
                }
                if(this.pFiltro.Entrada!=undefined){
                    this.FiltroC.Entrada = this.pFiltro.Entrada;
                }
                if(this.pFiltro.Anio!=undefined){
                    this.FiltroC.Anio = this.pFiltro.Anio;
                }
            }

            return this.FiltroC.Placeholder;
        },
    },
}
</script>